import styled from "styled-components";

import { FlexDiv } from "../../../../Atoms";
import Typography from "../../../../../foundation/Typography/V2";

export const PackageList = styled(FlexDiv)`
  gap: 8px;
  padding: 8px 0;
`;

export const StyledPackage = styled(FlexDiv)`
  cursor: pointer;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme?.colorsV2?.gray?.shade_100};
  border: 1px solid ${({ theme }) => theme?.colorsV2?.gray?.shade_200};
  width: 100%;
  text-align: center;
  img {
    position: absolute;
    top: 8px;
    right: 18px;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    margin-bottom: 8px;
  }
  &.active {
    background-color: ${({ theme }) => theme?.colors?.white};
    border: 1px solid ${({ theme }) => theme?.colorsV2?.shyft?.purple_text};
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const Title = styled(Typography)`
  margin-bottom: 8px;
  color: ${({ theme }) => theme?.colorsV2?.gray?.shade_600};
  &.active {
    color: ${({ theme }) => theme?.colorsV2?.primary?.shade_800};
  }
`;

export const Price = styled(Typography)`
  padding: 0 6px;
  color: ${({ theme }) => theme?.colorsV2?.gray?.shade_600};
  position: relative;
  &:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid ${({ theme }) => theme?.colorsV2?.warning?.shade_600};
    transform: rotate(-5.33deg);
  }
  &.active {
    color: ${({ theme }) => theme?.colorsV2?.gray?.shade_800};
  }
`;

export const DiscountedPrice = styled(Typography)`
  color: ${({ theme }) => theme?.colorsV2?.primary?.shade_900};
`;

export const Tag = styled(Typography)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -70%);
  color: ${({ theme }) => theme?.colorsV2?.gray?.shade_900};
  background-color: #ffdd2c;
  border: 1px solid ${({ theme }) => theme?.colorsV2?.warning?.shade_300};
  padding: 4px 16px;
  text-transform: uppercase;
  border-radius: 32px;
`;

export const OrContainer = styled(FlexDiv)`
  align-items: center;
  justify-content: center;
  position: relative;
  p {
    z-index: 3;
  }
  &:before {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 1px;
    width: 100%;
    background-color: ${({ theme }) => theme?.colorsV2?.gray?.shade_200};
    z-index: 1;
  }
  &:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 24px;
    width: 50px;
    background-color: ${({ theme }) => theme?.colors?.white};
    z-index: 2;
  }
`;

export const OrText = styled(Typography)``;

export const StyledSinglePackage = styled(StyledPackage)`
  width: 100%;
  text-align: unset;
  align-items: flex-start;
  margin-bottom: 24px;
  padding: 16px 32px;
`;

export const SingleTitle = styled(Title)`
  margin: 0 8px 0 0;
`;

export const SingleConsultationWrapper = styled(FlexDiv)`
  width: 100%;
`;

export const NotSure = styled(Typography)`
  margin-bottom: 8px;
`;
